import { Form, Input, Button, Modal } from "antd";
import { ReactComponent as AddIcon } from "../Icons/vuesax/add.svg"
import { showErrorToast } from "helpers/utils";
import { TEditContactEmail } from "api/services/models/types";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { addOrUpdateContactEmail } from "api/services/ContactService";
import { useState } from "react";

type TRecoveryEmailFormProps = {
    onClose: () => void;
};

const RecoveryEmailForm = ({ onClose }: TRecoveryEmailFormProps) => {
  const { accountId, webDUser } = useTDAuthentication();
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);

  const handleFieldsChange = () => {
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
    const values = form.getFieldsValue();
    const hasEmpty = Object.values(values).some(
      (v) => v === undefined || v === ""
    );
    
    setDisabled(hasErrors || hasEmpty);
  };

  const onFinish = (values: any) => {
    console.log("Submitted email:", values);
    if (!values) {
        showErrorToast("Please enter email.");
        return;
      }
      const updatedContact: TEditContactEmail = {
            accountId: accountId || "",
            email: values.email,
            contactId: webDUser?.user.contactId || 0,
            contactName: "",
          };
      addOrUpdateContactEmail(updatedContact);
      onClose();
  };
  
  return (
    <Modal
        centered={true}
        title={
          <div className="modal-header">
            Add Recovery Email
            <div className="modal-actions">
              <AddIcon onClick={() => onClose()} className="close-icon" />
            </div>
          </div>
        }
        open={true}
        onCancel={() => onClose()}
        footer={null}
        closable={false}
        >
    <Form
      form={form}
      name="recovery-email_form"
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      onFieldsChange={handleFieldsChange}
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Please enter your email" },
          { type: "email", message: "Please enter a valid email address" },
        ]}
      >
        <Input placeholder="Enter your email" />
      </Form.Item>

      <Form.Item
        label="Confirm Email"
        name="confirmEmail"
        dependencies={["email"]}
        rules={[
          { required: true, message: "Please confirm your email" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("email") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The two email addresses do not match")
              );
            },
          }),
        ]}
      >
        <Input placeholder="Re-enter your email" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block disabled={disabled}>
          Submit
        </Button>
      </Form.Item>
    </Form>
    </Modal>
  );
};

export default RecoveryEmailForm;
